import React, { useState, useEffect, useMemo, useCallback } from 'react';

// URL Script Anda
const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbynicAPNiaHZiaA-AQ0YNAWxICiHkNzWkE6PpXmnFKaC6RHyp4QwS4y8TDxt37qDQZH/exec';

const initialFormState = {
    'domain name': '', 'remarks': '', 'dr': '', 'bl': '', 'da': '', 'pa': '', 'ss': '', 
    'provider': '', 'account': '', 'hosting': '', 'used for': '', 'brand': '', 
    'domain status': '', 'nawala': '', 'akun cpanel': '', 'expired': ''
};

const headers = [
    { key: 'domain name', label: 'Domain Name' }, { key: 'remarks', label: 'Remarks' },
    { key: 'dr', label: 'DR' }, { key: 'bl', label: 'BL' }, { key: 'da', label: 'DA' },
    { key: 'pa', label: 'PA' }, { key: 'ss', label: 'SS' }, { key: 'provider', label: 'Provider' },
    { key: 'account', label: 'Account' }, { key: 'hosting', label: 'Hosting' },
    { key: 'used for', label: 'Used For' }, { key: 'brand', label: 'Brand' },
    { key: 'domain status', label: 'Domain Status' }, { key: 'nawala', label: 'Nawala' },
    { key: 'akun cpanel', label: 'Akun cPanel' }, { key: 'expired', label: 'Expired' }
];

const mainDisplayHeaders = ['domain name', 'provider', 'brand'];
const detailHeaders = headers.filter(h => !mainDisplayHeaders.includes(h.key));

const ITEMS_PER_PAGE = 25;

// Font Awesome inspired SVG Icons
const PencilIcon = () => <svg aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" className="h-4 w-4"><path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"></path><path fillRule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clipRule="evenodd"></path></svg>;
const SaveIcon = () => <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7.707 10.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V6h5a2 2 0 012 2v7a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h5v5.586l-1.293-1.293zM9 4a1 1 0 012 0v2H9V4z"></path></svg>;
const SpinnerIcon = () => <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>;
const ChevronIcon = ({ expanded }) => <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 text-zinc-500 transition-transform duration-200 ${expanded ? 'rotate-180' : ''}`} viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" /></svg>;
const SearchIcon = () => <svg className="w-5 h-5 text-zinc-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd"></path></svg>;
const CloseIcon = () => <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>;
const TrashIcon = () => <svg aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" className="h-4 w-4"><path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd"></path></svg>;
const SortIcon = ({ direction }) => {
    if (!direction) {
        return <svg className="w-4 h-4 inline-block ml-1.5 text-zinc-600 group-hover:text-zinc-400 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 9l4-4 4 4m0 6l-4 4-4-4"></path></svg>;
    }
    return (
        <svg className={`w-4 h-4 inline-block ml-1.5 text-white transition-transform duration-200 ${direction === 'descending' ? 'rotate-180' : ''}`} fill="currentColor" viewBox="0 0 20 20">
            <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
    );
};


const SkeletonRow = () => (
  <tr className="animate-pulse">
    <td className="w-12 px-6 py-4"><div className="h-4 w-4 bg-zinc-800 rounded-md"></div></td>
    {mainDisplayHeaders.map(key => <td key={key} className="px-6 py-4"><div className="h-4 bg-zinc-800 rounded-md"></div></td>)}
    <td className="px-6 py-4"><div className="h-8 w-28 bg-zinc-800 rounded-md"></div></td>
  </tr>
);

function App() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [newItem, setNewItem] = useState(initialFormState);
  const [submitting, setSubmitting] = useState(false);
  const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);
  const [searchTerm, setSearchTerm] = useState('');
  const [providerFilter, setProviderFilter] = useState('all');
  
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [expandedRows, setExpandedRows] = useState(new Set());
  
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deletingItem, setDeletingItem] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch(SCRIPT_URL);
      if (!response.ok) throw new Error(`Gagal mengambil data: Server merespons dengan status ${response.status}`);
      
      const result = await response.json();
      if (result.error) throw new Error(result.error);

      if (!Array.isArray(result)) {
        throw new Error("Format data salah. Seharusnya array.");
      }

      setData(result);
    } catch (err) {
      if (err instanceof SyntaxError) {
        setError("Gagal mem-parsing data JSON. Pastikan izin Google Apps Script diatur ke 'Anyone'.");
      } else {
        setError(err.message);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const filteredData = useMemo(() => {
    let processedData = data.map((item, index) => ({ ...item, originalIndex: index }));

    // Sorting
    if (sortConfig.key) {
        processedData.sort((a, b) => {
            const valA = a[sortConfig.key] || '';
            const valB = b[sortConfig.key] || '';

            const isNumeric = !isNaN(parseFloat(valA)) && isFinite(valA) && !isNaN(parseFloat(valB)) && isFinite(valB);

            let comparison = 0;
            if (isNumeric) {
                comparison = parseFloat(valA) - parseFloat(valB);
            } else {
                comparison = valA.toString().toLowerCase().localeCompare(valB.toString().toLowerCase());
            }

            return sortConfig.direction === 'ascending' ? comparison : -comparison;
        });
    }

    // Filtering
    return processedData.filter(item => {
        if (providerFilter !== 'all' && item.provider?.toLowerCase() !== providerFilter.toLowerCase()) {
            return false;
        }
        if (!searchTerm) {
            return true;
        }
        return Object.values(item).some(value =>
            String(value).toLowerCase().includes(searchTerm.toLowerCase())
        );
    });
  }, [data, searchTerm, providerFilter, sortConfig]);
  
  const uniqueProviders = useMemo(() => {
      const providers = new Set(data.map(item => item.provider).filter(Boolean));
      return ['all', ...Array.from(providers)];
  }, [data]);
  
  const handleLoadMore = useCallback(() => {
    if (loading) return;
    setVisibleCount(prev => prev + ITEMS_PER_PAGE);
  }, [loading]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 200 && visibleCount < filteredData.length) {
        handleLoadMore();
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [visibleCount, filteredData, handleLoadMore]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewItem(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      const payload = { action: 'create', data: newItem };
      const response = await fetch(SCRIPT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      if (result.status === 'success') {
        setData(prevData => [...prevData, newItem]);
        setNewItem(initialFormState);
      } else { throw new Error(result.message || 'Gagal menambahkan data.'); }
    } catch (err) { setError(err.message); } finally { setSubmitting(false); }
  };
  
  const handleEditClick = (item) => {
    setEditingItem({ data: { ...item }, originalIndex: item.originalIndex });
    setIsEditModalOpen(true);
  };

  const handleUpdateItem = async () => {
    if (!editingItem) return;
    setIsUpdating(true);
    setError(null);
    try {
      const payload = { action: 'update', rowIndex: editingItem.originalIndex, data: editingItem.data };
      const response = await fetch(SCRIPT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      if (result.status === 'success') {
        const updatedData = [...data];
        updatedData[editingItem.originalIndex] = editingItem.data;
        setData(updatedData);
        setIsEditModalOpen(false);
        setEditingItem(null);
      } else { throw new Error(result.message || 'Gagal memperbarui data.'); }
    } catch (err) { setError(err.message); } finally { setIsUpdating(false); }
  };
  
  const handleDeleteClick = (item) => {
    setDeletingItem(item);
    setIsDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    if (!deletingItem) return;
    setIsDeleting(true);
    setError(null);
    try {
      const payload = { action: 'delete', rowIndex: deletingItem.originalIndex };
      const response = await fetch(SCRIPT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      if (result.status === 'success') {
        setData(prevData => prevData.filter((_, index) => index !== deletingItem.originalIndex));
        setIsDeleteModalOpen(false);
        setDeletingItem(null);
      } else { throw new Error(result.message || 'Gagal menghapus data.'); }
    } catch (err) { setError(err.message); } finally { setIsDeleting(false); }
  };
  
  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditingItem(prev => ({ ...prev, data: { ...prev.data, [name]: value } }));
  };

  const toggleRowExpansion = (index) => {
    setExpandedRows(prev => {
        const newSet = new Set(prev);
        if (newSet.has(index)) {
            newSet.delete(index);
        } else {
            newSet.add(index);
        }
        return newSet;
    });
  };

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };


  return (
    <div className="bg-black min-h-screen font-sans text-gray-50">
      <div className="container mx-auto p-4 sm:p-6 lg:p-8">
        <header className="text-center mb-10">
          <h1 className="text-5xl font-bold text-white bg-clip-text text-transparent bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 py-2">
            Database Domain V1.0
          </h1>
          <p className="text-lg text-gray-400 mt-2">Domain Management By Venom777</p>
        </header>

        {error && (
          <div className="bg-red-900 bg-opacity-30 border border-red-700 text-red-300 p-4 mb-6 rounded-lg" role="alert">
            <p className="font-bold">Terjadi Kesalahan</p>
            <p>{error}</p>
          </div>
        )}

        <div className="p-[1.5px] bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 rounded-xl mb-8">
          <div className="bg-[#121212] p-6 rounded-xl shadow-lg">
            <h2 className="text-2xl font-semibold mb-5 text-white">Tambah Domain Baru</h2>
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-4">
                {headers.map(header => (
                  <input key={header.key} type="text" name={header.key} value={newItem[header.key]} onChange={handleInputChange} placeholder={header.label} className="w-full p-3 bg-zinc-900 border border-zinc-700 rounded-lg focus:ring-2 focus:ring-gray-400 focus:border-gray-400 transition placeholder:text-zinc-500" disabled={submitting}/>
                ))}
              </div>
              <button type="submit" className="w-full bg-gray-50 text-black font-bold py-3 px-4 rounded-lg hover:bg-gray-200 transition disabled:bg-zinc-700 disabled:text-zinc-400 flex items-center justify-center gap-2" disabled={submitting}>
                {submitting ? <SpinnerIcon /> : <SaveIcon />}
                <span>{submitting ? 'Menyimpan...' : 'Simpan ke Database'}</span>
              </button>
            </form>
          </div>
        </div>
        
        <div className="p-[1.5px] bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 rounded-xl">
          <div className="bg-[#121212] rounded-xl shadow-lg overflow-hidden">
            <div className="p-6">
              <h2 className="text-2xl font-semibold mb-4 text-white">Data dari Sheet</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="relative md:col-span-2">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <SearchIcon />
                  </span>
                  <input type="text" placeholder="Cari di semua kolom..." className="w-full p-3 pl-10 bg-zinc-900 border border-zinc-700 rounded-lg focus:ring-2 focus:ring-gray-400 placeholder:text-zinc-500" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                </div>
                <select className="w-full p-3 bg-zinc-900 border border-zinc-700 rounded-lg focus:ring-2 focus:ring-gray-400" value={providerFilter} onChange={(e) => setProviderFilter(e.target.value)}>
                  {uniqueProviders.map(provider => (<option key={provider} value={provider}>{provider === 'all' ? 'Semua Provider' : provider}</option>))}
                </select>
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full">
                <thead className="border-b border-zinc-800">
                  <tr>
                    <th className="w-12 px-6 py-3"></th>
                    {headers.filter(h => mainDisplayHeaders.includes(h.key)).map(h => 
                        <th key={h.key} className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">
                            <button onClick={() => requestSort(h.key)} className="flex items-center group focus:outline-none">
                                <span>{h.label}</span>
                                <SortIcon direction={sortConfig.key === h.key ? sortConfig.direction : null} />
                            </button>
                        </th>
                    )}
                    <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">Aksi</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-zinc-800">
                  {loading ? ( Array.from({ length: 10 }).map((_, i) => <SkeletonRow key={i} />)
                  ) : filteredData.length > 0 ? (
                    filteredData.slice(0, visibleCount).map((item) => (
                      <React.Fragment key={item.originalIndex}>
                        <tr className="hover:bg-zinc-900 cursor-pointer" onClick={() => toggleRowExpansion(item.originalIndex)}>
                          <td className="px-6 py-4">
                            <ChevronIcon expanded={expandedRows.has(item.originalIndex)} />
                          </td>
                          {mainDisplayHeaders.map(key => <td key={key} className="px-6 py-4 whitespace-nowrap text-sm">{item[key]}</td>)}
                          <td className="px-6 py-4 whitespace-nowrap text-sm" onClick={(e) => e.stopPropagation()}>
                            <div className="flex items-center gap-2">
                                <button onClick={() => handleEditClick(item)} className="bg-zinc-800 text-white font-bold p-2 rounded-lg hover:bg-zinc-700 transition flex items-center gap-1.5">
                                <PencilIcon />
                                </button>
                                <button onClick={() => handleDeleteClick(item)} className="bg-red-900/50 text-red-300 font-bold p-2 rounded-lg hover:bg-red-900/80 transition flex items-center gap-1.5">
                                <TrashIcon />
                                </button>
                            </div>
                          </td>
                        </tr>
                        {expandedRows.has(item.originalIndex) && (
                          <tr className="bg-black">
                            <td colSpan={mainDisplayHeaders.length + 3}>
                              <div className="p-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-x-4 gap-y-2">
                                {detailHeaders.map(h => (
                                  <div key={h.key} className="text-sm break-words">
                                    <span className="font-semibold text-zinc-400">{h.label}: </span>
                                    <span className="text-zinc-200">{item[h.key]}</span>
                                  </div>
                                ))}
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))
                  ) : ( <tr><td colSpan={mainDisplayHeaders.length + 3} className="px-6 py-10 text-center text-sm text-zinc-500">Tidak ada data yang cocok.</td></tr> )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      
      {isEditModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50 p-4">
          <div className="bg-[#121212] border border-zinc-800 p-8 rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <h2 className="text-2xl font-semibold mb-6 text-white">Edit Domain</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-6">
              {headers.map(h => (
                <div key={h.key}>
                  <label className="block text-sm font-medium text-zinc-400 mb-1">{h.label}</label>
                  <input type="text" name={h.key} value={editingItem.data[h.key] || ''} onChange={handleEditFormChange} className="w-full p-3 bg-zinc-900 border border-zinc-700 rounded-lg focus:ring-2 focus:ring-gray-400 focus:border-gray-400 transition" />
                </div>
              ))}
            </div>
            <div className="flex justify-end gap-4 mt-8">
              <button onClick={() => setIsEditModalOpen(false)} className="bg-zinc-800 text-white font-bold py-2 px-4 rounded-lg hover:bg-zinc-700 transition flex items-center gap-2">
                <CloseIcon />
                <span>Batal</span>
              </button>
              <button onClick={handleUpdateItem} disabled={isUpdating} className="bg-gray-50 text-black font-bold py-2 px-6 rounded-lg hover:bg-gray-200 transition disabled:bg-zinc-700 disabled:text-zinc-400 flex items-center gap-2">
                {isUpdating ? <SpinnerIcon /> : <SaveIcon />}
                <span>{isUpdating ? 'Menyimpan...' : 'Simpan Perubahan'}</span>
              </button>
            </div>
          </div>
        </div>
      )}
      
      {isDeleteModalOpen && (
         <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50 p-4">
          <div className="bg-[#121212] border border-zinc-800 p-8 rounded-xl shadow-2xl w-full max-w-md">
            <h2 className="text-2xl font-semibold mb-4 text-white">Konfirmasi Hapus</h2>
            <p className="text-zinc-400 mb-6">
              Apakah Anda yakin ingin menghapus domain <strong className="text-white">{deletingItem?.['domain name']}</strong>? Aksi ini tidak dapat dibatalkan.
            </p>
            <div className="flex justify-end gap-4 mt-8">
              <button onClick={() => setIsDeleteModalOpen(false)} className="bg-zinc-800 text-white font-bold py-2 px-4 rounded-lg hover:bg-zinc-700 transition">
                Batal
              </button>
              <button onClick={confirmDelete} disabled={isDeleting} className="bg-red-600 text-white font-bold py-2 px-6 rounded-lg hover:bg-red-700 transition disabled:bg-red-900/50 flex items-center gap-2">
                {isDeleting ? <SpinnerIcon /> : <TrashIcon />}
                <span>{isDeleting ? 'Menghapus...' : 'Hapus'}</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;

